import BasePostApi from "../BasePostApi";

export default abstract class BasePostIdApi extends BasePostApi {
	protected override getBaseUrl(params: Record<string, string>) {
		return `${super.getBaseUrl(params)}/${params["postId"]}`;
	}
}
